export type EventLaunchMode = "phone" | "screen";
const SCREEN_CODE = /^[2-9A-HJ-NP-Z]{8}$/;

export function normalizeScreenCode(input: string | null): string {
  const code = (input ?? "").replace(/[\s-]/g, "").toUpperCase();
  return SCREEN_CODE.test(code) ? code : "";
}

export function readEventLaunch(search: string): { mode: EventLaunchMode | null; screenCode: string } {
  const query = new URLSearchParams(search);
  const mode = query.get("launch");
  return { mode: mode === "phone" || mode === "screen" ? mode : null,
    screenCode: mode === "screen" ? normalizeScreenCode(query.get("screenCode")) : "" };
}

export function eventLaunchUrl(mode: EventLaunchMode, screenCode = ""): string {
  const query = new URLSearchParams({ launch: mode });
  const code = normalizeScreenCode(screenCode);
  if (mode === "screen" && code) query.set("screenCode", code);
  return `/events/new?${query}`;
}

export function eventLaunchLoginUrl(search: string): string {
  // LoginPage performs the one authoritative same-origin normalization. Its
  // input must remain relative: passing an already-normalized absolute URL
  // would deliberately fail that guard and send the HOST to the dashboard.
  const next = `/events/new${search.startsWith("?") ? search : ""}`;
  return `/login?next=${encodeURIComponent(next)}`;
}

// Navigation hints only: these URLs never pair a screen or START a game.
export function createdEventDestination(search: string, eventId: string, roomId: string): string {
  const launch = readEventLaunch(search);
  if (launch.screenCode) return `/screen/connect?${new URLSearchParams({ code: launch.screenCode, event: eventId })}`;
  if (launch.mode) return `/host/rooms/${encodeURIComponent(roomId)}${launch.mode === "screen" ? "?setup=screen" : ""}`;
  return `/host/events/${encodeURIComponent(eventId)}`;
}
